const KEY_IS_TWA = 'trustedWebActivity';

export const getTwaStatus = () => {
  return sessionStorage.getItem(KEY_IS_TWA);
};

export const storeTwaStatus = (value) => {
  return sessionStorage.setItem(KEY_IS_TWA, value);
};
